export default __webpack_public_path__ + "static/media/trash.cdd35fba.svg";